import React, { useCallback, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ActivityIcon, ClockIcon, MaximizeIcon } from 'lucide-react';
import { TradingViewChart } from './TradingViewChart';
import { TerminalOverlay } from './TerminalOverlay';
export function HeroTerminal() {
  const [expanded, setExpanded] = useState(false);
  const lastTapRef = useRef(0);

  /* Double tap (touch) / double click (mouse) on the terminal bar
     opens the floating full-screen terminal. */
  const handleTap = useCallback(() => {
    const now = Date.now();
    if (now - lastTapRef.current < 320) {
      lastTapRef.current = 0;
      setExpanded(true);
      return;
    }
    lastTapRef.current = now;
  }, []);
  const close = useCallback(() => setExpanded(false), []);
  return <section id="terminal" className="border-b border-line" data-id="element-8" data-mp="3luip0w1ain94">
      <div className="mx-auto w-full max-w-[1400px] px-5 pb-14 pt-12 sm:px-6 lg:px-10 lg:pb-20 lg:pt-24" data-id="element-9" data-mp="3lwvd7qxn5tum">
        <div className="grid gap-8 lg:grid-cols-12 lg:items-end lg:gap-10" data-id="element-10" data-mp="3h1zc81affw5d">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="lg:col-span-8" data-id="element-11" data-mp="2tqwwziao1zr5">
            <div className="mb-5 flex items-center gap-3" data-id="element-12" data-mp="2kw8q5npg0a08">
              <span className="h-px w-6 bg-cyan-vip sm:w-8" data-id="element-13" data-mp="2oyc36grrfmnm" />
              <span className="font-mono text-[10px] uppercase tracking-[0.24em] text-cyan-vip sm:text-[11px] sm:tracking-[0.28em]" data-id="element-14" data-mp="2azci1j3ghpw7">
                Protocolo de Apertura VIP
              </span>
            </div>
            <h1 className="max-w-4xl text-[32px] font-bold leading-[1] tracking-[-0.03em] text-white sm:text-5xl sm:leading-[0.98] sm:tracking-[-0.035em] lg:text-[76px]" data-id="element-15" data-mp="21zz7en3liv9w">
              <span className="text-glow-white" data-id="element-16" data-mp="7ufhbm3jxz6">La Precisión no es</span>{' '}
              <span className="text-white/35" data-id="element-17" data-mp="5q2m467zomr">una opinión.</span>
              <br className="hidden sm:block" data-id="element-18" data-mp="484okx56r4i9" />{' '}
              <span className="text-glow-gold text-gold-vip" data-id="element-19" data-mp="1d6cv2diny21w">
                Es una regla matemática.
              </span>
            </h1>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="lg:col-span-4" data-id="element-20" data-mp="185ykanpoge06">
            <p className="max-w-md text-[14px] leading-relaxed text-white/55 sm:text-[15px]" data-id="element-21" data-mp="1vwcbyd4coau8">
              Bienvenido a la Terminal de indicadoresvip.com. Monitorea el
              XAU/USD en tiempo real y aplica el Protocolo de Apertura VIP.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.985
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="neon-underlight relative isolate mx-auto mt-10 w-full max-w-[1000px] lg:mt-14" data-id="element-22" data-mp="1i4xu49m6ifor">
          <div className="neon-edge overflow-hidden rounded-lg border border-cyan-vip/20 bg-ink-800" data-id="element-23" data-mp="2i74246dji83p">
            <div onClick={handleTap} onDoubleClick={() => setExpanded(true)} className="flex cursor-pointer select-none flex-wrap items-center justify-between gap-x-4 gap-y-2 border-b border-line px-3 py-2.5 transition-colors duration-150 ease-out hover:bg-white/[0.03] sm:px-4 sm:py-3" data-id="element-24" data-mp="2n4mc803amtda">
              <div className="flex items-center gap-2.5" data-id="element-25" data-mp="362ovdy95tw36">
                <span className="relative flex h-2 w-2" data-id="element-26" data-mp="3615ec5fojh0c">
                  <span className="absolute inline-flex h-full w-full rounded-full bg-cyan-vip opacity-60" data-id="element-27" data-mp="3auzvb13whhvq" />
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-cyan-vip" data-id="element-28" data-mp="3frqa7l3yy7fk" />
                </span>
                <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-cyan-vip sm:text-[11px] sm:tracking-[0.2em]" data-id="element-29" data-mp="3jw7v5nm2eqrx">
                  Live · OANDA:XAUUSD
                </span>
              </div>

              <div className="flex items-center gap-3 font-mono text-[10px] text-white/40 sm:gap-5 sm:text-[11px]" data-id="element-30" data-mp="3b4wgehthskvw">
                <span className="hidden items-center gap-1.5 sm:inline-flex" data-id="element-31" data-mp="373kwmsxautvm">
                  <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-32" data-mp="3kw0yvridmnvh" />
                  New York · 15M
                </span>
                <span className="hidden items-center gap-1.5 lg:inline-flex" data-id="element-33" data-mp="2s84xwalry9sw">
                  <ActivityIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-34" data-mp="2sa7rt5q1sn2w" />
                  Trading Sessions
                </span>
                <button type="button" onClick={event => {
                event.stopPropagation();
                setExpanded(true);
              }} aria-label="Abrir terminal en ventana flotante" className="inline-flex items-center gap-1.5 rounded border border-white/10 px-2 py-1 text-[10px] text-white/60 transition-colors duration-150 ease-out hover:border-cyan-vip/50 hover:text-cyan-vip focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-cyan-vip sm:text-[11px]" data-id="element-35" data-mp="326uabnuwj21r">
                  <MaximizeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-36" data-mp="1le798te0mqj6" />
                  <span className="hidden sm:inline" data-id="element-37" data-mp="1lga71zletnyg">Doble toque ·&nbsp;</span>
                  Expandir
                </button>
              </div>
            </div>

            <div className="bg-ink p-1.5 sm:p-2" data-id="element-38" data-mp="2e34qquaekjav">
              <TradingViewChart data-id="element-39" data-mp="2i3yffpvo624t" />
            </div>
          </div>
        </motion.div>
      </div>

      <AnimatePresence data-id="element-40" data-mp="24d1mtz1qtkxr">
        {expanded && <TerminalOverlay onClose={close} data-id="element-41" data-mp="24c0bdtgtewfi" />}
      </AnimatePresence>
    </section>;
}